import React, { useState } from "react";
import { Input } from "antd";
import "./style.css";

const FloatInput = ({ label, defaultFocus = false, value, placeholder, type, required, size, onChange, ...props } ) => {
  const [focus, setFocus] = useState(defaultFocus);

  if (!placeholder) placeholder = label;

  const isOccupied = focus || (value && value.length !== 0);

  const labelClass = isOccupied ? "label as-label" : "label as-placeholder";

  const requiredMark = required ? <span className='text-danger'>*</span> : null;

  return (
    <div
      className='float-label'
      onBlur={() => setFocus(false)}
      onFocus={() => setFocus(true)}
    >
      <Input onChange={onChange} type={type} defaultValue={value} {...props} size={size || "large"} />
      <label className={labelClass}>
        {isOccupied ? label : placeholder} {requiredMark}
      </label>
    </div>
  );
};

export default FloatInput;
